/** Id of the product page wrapper around the sections below the display. */
export const PRODUCT_PAGE_SECTIONS_ID = "product-page-sections";

type SectionConfig = { type?: string; props?: { items?: unknown[] } };

/**
 * `renderComponent` returns nothing for an accordion without items, so such a
 * section cannot be a scroll destination.
 */
const rendersContent = (section: unknown): boolean => {
  if (!section || typeof section !== "object") return false;
  const { type, props } = section as SectionConfig;
  if (type === "accordion") return !!props?.items?.length;
  return true;
};

/**
 * Whether the product page renders any sections below the display.
 * `renderConfig.Components` may be an array of single-key objects or a keyed
 * object.
 */
export const hasProductPageSections = (
  components: unknown[] | Record<string, unknown> | null | undefined,
): boolean => {
  if (!components) return false;
  const sections = Array.isArray(components)
    ? components.map((entry) =>
        entry && typeof entry === "object" ? Object.values(entry)[0] : entry,
      )
    : Object.values(components);
  return sections.some(rendersContent);
};
